import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import getCorePersonalStore from "../../stores/core/core-personal-store";

const UpdatingVersion = withLiteObserverAndTheme<{
  isFirebaseTriggered?: boolean;
}>((props) => {
  const { theme, isFirebaseTriggered } = props;
  const { colors } = theme;

  const newVersion = getCorePersonalStore().adminNewUpdateVersion.get();

  const updateText = isFirebaseTriggered
    ? i18n.get("APP_CONTROL_SYSTEM_UPDATE_IN_PROGRESS")
    : `${i18n.get("UPDATING_TO_VERSION")} ${newVersion}`;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-end"
      withShadow={true}
      width={2000}
      height={1080}
      color={colors.all.transparent}
      style={{
        position: "fixed",
        top: 0,
        zIndex: 5
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="center"
        alignItems="center"
        withShadow={true}
        width={1660}
        height={1080}
        color={colors.all.white}
        style={{
          position: "fixed",
          top: 0,
          zIndex: 5
        }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={100}
          text={updateText}
          isSpan={false}
          color={colors.all.bondiBlue}
          style={{}}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default UpdatingVersion;
